import { render, staticRenderFns } from "./AddSettlementItemCommentModal.vue?vue&type=template&id=d03f97b2&"
import script from "./AddSettlementItemCommentModal.vue?vue&type=script&lang=js&"
export * from "./AddSettlementItemCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports